export const state = {
  isAdmin: false,
  isPremium: false,
  plan: {},
  performingRequest: false,
  activeDashboardSection: null,
  currentUser: null,
  currentUserFavorites: [],
  userProfile: {},
  plans: [],
  professionalProfile: {
    name: '',
    lastName: '',
    profilePictureUrl: '',
    title: '',
    email: '',
    address: {
      street: '',
      number: '',
      neighborhood: '',
      city: '',
      state: '',
      comp: ''
    },
    phoneNumber1: '',
    phoneNumber2: '',
    biography: '',
    services: {
      online: false,
      inPerson: false
    },
    specialties: [],
    insurances: [],
    discount: 0,
    socialNetworks: {
      instagram: '',
      facebook: '',
      twitter: '',
      linkedin: ''
    }
  },
  posts: [],
  hiddenPosts: [],
  specialties: [],
  users: [],
  locationName: '',
  coordinates: {}
}

export default state
